import { Component, Input, OnInit } from '@angular/core';
import { Observable } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { OnDestroy } from "../../../../core/shared/rxjs-helpers";
import { Dashboard } from "../../../../store/reducers/reporting.reducer";
import { Store } from "@ngrx/store";
import { selectReport } from "../../../../store/selectors/reporting.selectors";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { filter, tap } from "rxjs/operators";
import { TitleService } from "../../../../core/services/title.service";
import { setPageHeaderContent } from 'src/app/store';
import {
  ProductDashboardHeaderComponent
} from 'src/app/views/product/nav/product-dashboard-header/product-dashboard-header.component';
import { PageTrackingData } from 'src/app/core/analytics-next/analytics-next';
import { LookerEmbedSdkComponent } from "../../../../core/ui/looker-embed-sdk/looker-embed-sdk.component";
import { AsyncPipe } from "@angular/common";
import { FullscreenToggleDirective } from "../../../../core/directives/fullscreen-toggle.directive";

@Component({
    selector: 'app-custom-dashboard',
    templateUrl: './custom-dashboard.component.html',
  imports: [ProductDashboardHeaderComponent, LookerEmbedSdkComponent, AsyncPipe, FullscreenToggleDirective]
})
export class CustomDashboardComponent extends OnDestroy implements OnInit {
  report$: Observable<Dashboard>;
  loading: boolean = false;

  @Input() dashboard: string;
  @Input() theme: string = null;

  constructor(private store: Store,
              private titleService: TitleService,
              private activatedRoute: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.activatedRoute.params.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(({ report }) => {
      if (!report) {
        report = this.dashboard;
      }
      this.report$ = this.store.select(selectReport(report)).pipe(
        filter((report) => !!report),
        tap((report) => this.setTitle(report)),
      )
    });
  }

  setTitle(dashboard: Dashboard) {
    const title = dashboard.title;
    this.titleService.setTitle(title, this.trackingData(title));
    this.store.dispatch(setPageHeaderContent({ pageTitle: title }));
  }

  onLoaded($event) {
    const { dashboard } = $event;
    const title = dashboard.title;
    if (title?.length) {
      this.titleService.setTitle(title, this.trackingData(title));
    }
  }

  private trackingData(dashboard: string): PageTrackingData {
    return {
      name: 'Custom Looker Dashboard',
      category: 'reports',
      properties: { dashboard, tag: 'custom-looker-dashboard' }
    };
  }

}
